import { setAnalyticsEnabled } from "./track"

/** Production GTM container for Gamba. Not loaded on staging or local dev. */
export const PROD_GTM_CONTAINER_ID = "GTM-MSCNMSC4"

let initialized = false

/**
 * Injects GTM script + noscript fallback. Idempotent; safe to call once at bootstrap.
 */
export function initGoogleTagManager(
  containerId: string = PROD_GTM_CONTAINER_ID
): void {
  if (initialized || typeof window === "undefined" || typeof document === "undefined") {
    return
  }
  initialized = true
  setAnalyticsEnabled(true)

  const dataLayerName = "dataLayer"
  const w = window as Window & { dataLayer?: Record<string, unknown>[] }
  w[dataLayerName] = w[dataLayerName] || []
  w[dataLayerName].push({
    "gtm.start": Date.now(),
    event: "gtm.js",
  })

  const script = document.createElement("script")
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`
  document.head.appendChild(script)

  const noscript = document.createElement("noscript")
  const iframe = document.createElement("iframe")
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${containerId}`
  iframe.height = "0"
  iframe.width = "0"
  iframe.style.display = "none"
  iframe.style.visibility = "hidden"
  noscript.appendChild(iframe)
  document.body.insertBefore(noscript, document.body.firstChild)
}
